<section
  class="rs-content-wrapper rs-header-has-level2"
  *ngIf="!error || pending || productsLoaded"
  id="nspManageContainer"
>
  <mprd-nsp-manage-skeleton *ngIf="!productsLoaded"></mprd-nsp-manage-skeleton>
  <main id="maincontent" role="main" *ngIf="productsLoaded">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-txt-c2 rs-has-subtit" data-cy="nspManageTitle">
            {{ 'nsp.manage.title' | translate }}
          </h1>
          <div class="rs-panel-big rs-bg-c2 clearfix">
            <mprd-nsp-statistics-banner
              *ngIf="('nsp.manage.statistics.enabled' | translate) === 'true'"
            ></mprd-nsp-statistics-banner>
            <h2 class="rs-tit3" data-cy="nspManageSubTitle">
              {{ 'nsp.manage.subtitle' | translate }}
            </h2>
            <ng-container *ngIf="internetProducts.length > 0">
              <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
                <div class="rs-flex-column rs-flex-shrink">
                  <h3 class="rs-tit5" data-cy="nspManageInternetTitle">
                    {{ 'nsp.manage.internet.title' | translate }}
                  </h3>
                </div>
                <div class="rs-flex-column" data-cy="nspManageInternetPrice"  *ngIf="!isAlwaysProtected">
                  <p class="rs-txt-s3 rs-padding-bottom1-m">
                    {{ 'nsp.manage.internet.price' | translate }}
                  </p>
                </div>
              </div>
              <p
                data-cy="nspManageInternetDescription"
                [innerHTML]="'nsp.manage.internet.description' | translate"
              ></p>
              <mprd-nsp-internet-list-component
                [products]="internetProducts"
                data-cy="nspManageInternetList"
              ></mprd-nsp-internet-list-component>
              <div class="rs-me"></div>
            </ng-container>
            <ng-container *ngIf="mobileProducts.length > 0">
              <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
                <div class="rs-flex-column rs-flex-shrink">
                  <h3 class="rs-tit5" data-cy="nspManageMobileTitle">
                    {{ 'nsp.manage.mobile.pack.title' | translate }}
                  </h3>
                </div>
                <div class="rs-flex-column" *ngIf="!isAlwaysProtected">
                  <p class="rs-txt-s3 rs-padding-bottom1-m" data-cy="nspManageMobilePrice">
                    {{ 'nsp.manage.mobile.pack.price' | translate }}
                  </p>
                </div>
              </div>
              <mprd-nsp-mobile-list-component
                [products]="mobileProducts"
                (hasChanged)="handleHasChanged($event)"
                data-cy="nspManageMobileList"
              ></mprd-nsp-mobile-list-component>
              <div class="rs-me"></div>
            </ng-container>
            <div class="rs-flex-row rs-flex-dir-col-small-only">
              <div class="rs-flex-column rs-order-m2">
                <button
                  class="rs-btn rs-btn-nl-so"
                  aria-haspopup="true"
                  [disabled]="!hasChanged"
                  (click)="confirmChanges()"
                  data-cy="nspManageConfirmUpdatesButton"
                  data-tms-event="button-click"
                  data-tms-button-zone="nsp"
                  attr.data-tms-button-name="{{ 'nsp.manage.button.confirm' | translate }}"
                >
                  {{ 'nsp.manage.button.confirm' | translate }}
                </button>
              </div>
              <div class="rs-flex-column rs-flex-shrink rs-order-m1" *ngIf="!isAlwaysProtected">
                <button
                  class="rs-btn rs-btn-second rs-btn-nl-m"
                  data-reveal-id="modalCease"
                  aria-haspopup="true"
                  data-cy="nspManageCancelSubscriptionButton"
                  data-tms-event="button-click"
                  data-tms-button-zone="nsp"
                  attr.data-tms-button-name="{{ 'nsp.manage.button.cancel' | translate }}"
                >
                  {{ 'nsp.manage.button.cancel' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</section>

<mprd-generic-modal
  [idModal]="'modalCease'"
  [title]="'nsp.manage.modal.cancelSubscriptions.title' | translate"
  [content]="'nsp.manage.modal.cancelSubscriptions.content' | translate"
  [cancelCTAName]="'nsp.manage.modal.cancelSubscriptions.cancel' | translate"
  [confirmCTAName]="'nsp.manage.modal.cancelSubscriptions.confirm' | translate"
  [confirmCTA]="modalCTAConfirm"
  [dataCy]="'nspManageCancelSubscriptionModal'"
>
</mprd-generic-modal>
